module.exports = __webpack_public_path__ + "img/reference65.f16eccac.jpg";